
export default {
  general_title: 'Tablero',
  admin: {
    title: 'Resumen de valoraciones',
    table_header_name: 'Nombre',
    table_header_dates: 'Periodo',
    table_header_status: 'Estado',
    table_header_enterprise: 'Empresa',
    table_header_team_members: 'Integrantes del equipo',
    to: 'hasta',
    status_pending: 'Pendiente',
    status_in_progress: 'En progreso',
    status_completed: 'Completada',
    no_data: 'Aún no se han realizado valoraciones'
  },
  enterprise: {
    title: 'Resumen de valoraciones',
    status: 'Estado',
    answers_percent: 'Porcentaje de respuesta',
    team_members: 'Integrantes del equipo',
    received: 'Respuestas recibidas',
    input_view_details: 'Ver detalles',
    no_evaluation_culture: 'Aún no se han realizado valoraciones',
    go_creation: 'Crear valoración',
    go_list: 'Ir al listado',
    view_evaluation_list: 'Ver listadode de valoraciones',
    status_pending: 'Pendiente',
    status_in_progress: 'En progreso',
    status_completed: 'Completada'
  },
  employee: {
    input_completed: 'Completar',
    input_continue: 'Continuar',
    input_start: 'Iniciar',
    input_reply: 'Responder',
    no_pending_activities: 'No posee valoraciones pendientes'
  }
}
